import { render, staticRenderFns } from "./doc-pindaan-harta_tidakalih.vue?vue&type=template&id=f9d10cb2&"
import script from "./doc-pindaan-harta_tidakalih.vue?vue&type=script&lang=js&"
export * from "./doc-pindaan-harta_tidakalih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports